// START GENAI@CHATGPT4
export type QuestionsResponse = {
  code: number;
  displayFormat: string;
  message: string;
  questions: Question[];
  quizDuration: string;
  success: boolean;
}

export type QuestionOption = {
  id: string;
  option: string;
  sort: number;
};

export type Question = {
  id: number;
  options: QuestionOption[];
  qns: string;
  questionDuration?: string;
  score: number;
  shuffle?: boolean;
  type: string;
  url?: string;
};

export type QuizAnswerPayLoad = {
  promoId: string;
  quizId: string;
  token: string;
  answer: Answer[];
}

export type Answer = {
  key: string;
  values: string[];
}

export type QuizInitPayLoad = {
  promoId: string;
  quizId: string;
}

// END GENAI@CHATGPT4

export const QUIZ_QUESTION_TYPE = {
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  SINGLE_CHOICE: "SINGLE_CHOICE",
  DATE: "DATE"
}

export const QUIZ_DISPLAY_FORMAT = {
  ALL_TOGETHER: "ALL_TOGETHER",
  ONE_AT_A_TIME: "ONE_AT_A_TIME"
}

export const QUIZ_FINISH_SAMPLE = {
  success: true,
  message: "string",
  code: "string"
}

export const QUIZ_LEADERBOARD_SAMPLE = {
  success: true,
  message: "string",
  code: "string",
  resultSet: [
    {
      nickname: "Test 1",
      correctAns: "Answer 1",
      points: "60",
      maskedEmail: "test@visa.com ",
      time: "00:01:00"
    }
  ]
}

export type ParsedQuizConfig = {
  id?: string;
  heading?: string;
  description?: string;
  resultQnsCorrectLabel?: string;
  resultHeading?: string;
  resultTimeSpendLabel?: string;
  resultTotalScoreLabel?: string;
  quizSubmitButtonLabel?: string;
  quizNextButtonLabel?: string;
  quizType?: string;
}


export const QUIZ_GET_QUESTION_SAMPLE = {
  "success": true,
  "code": "string",
  "message": "string",
  "displayFormat": "ALL_TOGETHER",
  "quizDuration":"00:10:00",
  "questions": [{
    "id":1,
    "qns":"1 question",
    "type":"MULTIPLE_CHOICE",
    "score": 20,
    "options":[
      {"id":"key1","option":"Test 1"},
      {"id":"key2","option":"Test 2"},
      {"id":"key3","option":"Test 3"},
      {"id":"key4","option":"Test 4"}]
  }  as Question,
    {
      "id":2,
      "qns":"2 question",
      "type":"SINGLE_CHOICE",
      "score":0,
      "options":[
        {"id":"key1","option":"1-2"},
        {"id":"key2","option":"1-3"},
        {"id":"key3","option":"1-2"},
        {"id":"key4","option":"1-3"}]
    }  as Question,
    {
      "id":3,
      "qns":"3 question date",
      "type":"DATE",
      "score":0
    } as Question
  ]
}

export const QUIZ_GET_RESULT_SAMPLE = {
  "success": true,
  "message": "string",
  "code": "string",
  "result": {
    "email": "Test 1",
    "correctAns": "2",
    "score": "100",
    "maskedEmail": "tabxxx@visa.com",
    "time": "00:01:00"
  }
}

export const QUIZ_START_SAMPLE = {
  "success": true,
  "message": "string",
  "code": "string",
  "token": "string"
}
